import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-white border-y border-[#D89B16]/30" data-id="element-18" data-mp="22fmv4tjdi00j">
      <div className="max-w-5xl mx-auto" data-id="element-19" data-mp="22diuqlkonj50">
        <div className="text-center mb-16" data-id="element-20" data-mp="1ydi8wfv985nx">
          <p className="text-[#1E4ED8] font-bold tracking-widest uppercase mb-2" data-id="element-21" data-mp="1yet8e3ho2r98">
            Included with your purchase at no additional cost
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#081632]" data-id="element-22" data-mp="15q5jlxxpljqx">
            🎁 <span className="text-[#D89B16]" data-id="element-23" data-mp="1jhamra0acu60">5 Professional Bonus Guides</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-24" data-mp="1epixr3ws2whz">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white border border-[#D89B16]/40 rounded-2xl p-8 shadow-sm shadow-[#1E4ED8]/10 relative flex flex-col ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-25" data-mp="qzyd8gkz7r6l" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-[#081632] text-[#D89B16] px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-26" data-mp="2oh8yyurx51fd">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-[#F5F7FB] border border-[#D89B16]/40 rounded-full flex items-center justify-center text-[#D89B16] mb-4" data-id="element-27" data-mp="1vrsag87f64of">
                <Gift size={24} data-id="element-28" data-mp="20q3kaixpsf6n" />
              </div>
              <h3 className="text-xl font-serif font-bold mb-2 pr-28 text-[#081632]" data-id="element-29" data-mp="25qrl1wbqwae2">{bonus.title}</h3>
              <p className="text-[#1E4ED8] text-sm italic mb-4 border-l-2 border-[#D89B16] pl-4" data-id="element-30" data-mp="3c7d08vhmwp37">
                {bonus.subtitle}
              </p>
              <p className="text-slate-700 text-sm mb-4 leading-relaxed" data-id="element-31" data-mp="3h7ra8j2sq93v">{bonus.intro}</p>
              <ul className="space-y-2 mb-6 flex-grow" data-id="element-32" data-mp="1h1kgc7lglazz">
                {bonus.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-33" data-mp="1c6esv4cero9s">
                    <CheckCircle2 size={16} className="text-[#D89B16] shrink-0 mt-0.5" data-id="element-34" data-mp="1q2sf0qrw0dul" />
                    <span className="text-slate-700 text-sm" data-id="element-35" data-mp="1m3jkhjp0wbxz">{bullet}</span>
                  </li>)}
              </ul>
              <p className="text-[#081632] font-semibold text-sm italic mt-auto pt-4 border-t border-[#D89B16]/30" data-id="element-36" data-mp="yata3ewrq0pt">
                {bonus.closing}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}